var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('h1',[_vm._v("This is an about page")]),_c('p',[_vm._v("params: "+_vm._s(_vm.$route.params))]),_c('p',[_vm._v("query: "+_vm._s(_vm.$route.query))]),_c('p',[_vm._v("lang: "+_vm._s(_vm.$lang))])])
}
var staticRenderFns = []

export { render, staticRenderFns }